import React, {PropsWithChildren} from "react";
import {DefaultValues, FieldValues, Resolver, SubmitHandler} from "react-hook-form";

interface Props<TFormValues extends FieldValues> extends PropsWithChildren {
    defaultValues?: DefaultValues<TFormValues>;
    onSubmit?: SubmitHandler<TFormValues>;
    onEnter?: () => void | Promise<void>;
    onError?: (errors: Object, e?: Event) => Promise<void>;
    formClass?: string;
    handleSubmit?: any;
}

export function Form<TFormValues extends Record<string, any> = Record<string, any>>({
    handleSubmit,
    onEnter,
    onSubmit,
    onError,
    formClass,
    children,
}: Props<TFormValues>) {
    const submit = handleSubmit
        ? handleSubmit(onSubmit, onError ? onError : () => {
        })
        : undefined;

    const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
        if (event.key === 'Enter') {
            if (!handleSubmit && onEnter) {
                onEnter();
                event.preventDefault();
            }
        }
    };

    return (
        <form onSubmit={submit} className={formClass} noValidate onKeyDown={handleKeyDown}>
            {children}
        </form>
    );
}
